import { useEffect, useRef, useSyncExternalStore } from 'react'
import { tg } from './webapp'

/**
 * Нативная кнопка «Назад» Telegram: показана, пока передан обработчик; null — скрыта.
 * Обработчик можно менять между рендерами без мигания кнопки.
 */
export function useBackButton(onBack: (() => void) | null | undefined): void {
  const ref = useRef(onBack)
  useEffect(() => {
    ref.current = onBack
  })
  const visible = Boolean(onBack)
  useEffect(() => {
    if (!visible) {
      tg.backButton.hide()
      return
    }
    tg.backButton.show(() => ref.current?.())
    return () => tg.backButton.hide()
  }, [visible])
}

/** Текущая схема Telegram/системы с подпиской на изменения. */
export function useColorScheme(): 'light' | 'dark' {
  return useSyncExternalStore(
    (cb) => tg.onThemeChange(() => cb()),
    () => tg.colorScheme,
    () => 'dark',
  )
}

/** Вызвать ready/expand/disableVerticalSwipes один раз при старте приложения. */
export function initTelegram(): void {
  tg.ready()
  tg.expand()
  tg.disableVerticalSwipes()
}
